/* eslint-disable @repo/internal/react/require-jsdoc, import/order, @repo/internal/codegen/signed-source-integrity */

import React from 'react';

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * To add new logos, update `platform/services/design-system-docs/scripts/codegen-logos/index.tsx`
 *
 * @codegen <<SignedSource::ea846bcbc558bfc029d5043948e4d06d>>
 * @codegenId myPartialCodegen
 * @codegenCommand afm workspace @atlaskit/website-constellation codegen:logos
 */
import { withAssetPrefix } from 'gatsby';

import { Stack } from '@atlaskit/primitives/compiled/stack';

import AssetCard from '../../../components/content-types/asset-card';
import analyticsAppDark from './_assets/thumbnails/analytics_app_dark.svg';
import analyticsApp from './_assets/thumbnails/analytics_app_light.svg';
import analyticsAttributionDark from './_assets/thumbnails/analytics_attribution_dark.svg';
import analyticsAttribution from './_assets/thumbnails/analytics_attribution_light.svg';
import assetsAppDark from './_assets/thumbnails/assets_app_dark.svg';
import assetsApp from './_assets/thumbnails/assets_app_light.svg';
import assetsAttributionDark from './_assets/thumbnails/assets_attribution_dark.svg';
import assetsAttribution from './_assets/thumbnails/assets_attribution_light.svg';
import atlasAppDark from './_assets/thumbnails/atlas_app_dark.svg';
import atlasApp from './_assets/thumbnails/atlas_app_light.svg';
import atlasAttributionDark from './_assets/thumbnails/atlas_attribution_dark.svg';
import atlasAttribution from './_assets/thumbnails/atlas_attribution_light.svg';
import atlassianAccessPropertyDark from './_assets/thumbnails/atlassian-access_property_dark.svg';
import atlassianAccessProperty from './_assets/thumbnails/atlassian-access_property_light.svg';
import atlassianBlogPropertyDark from './_assets/thumbnails/atlassian-blog_property_dark.svg';
import atlassianBlogProperty from './_assets/thumbnails/atlassian-blog_property_light.svg';
import atlassianCertificationPropertyDark from './_assets/thumbnails/atlassian-certification_property_dark.svg';
import atlassianCertificationProperty from './_assets/thumbnails/atlassian-certification_property_light.svg';
import atlassianCommunityPropertyDark from './_assets/thumbnails/atlassian-community_property_dark.svg';
import atlassianCommunityProperty from './_assets/thumbnails/atlassian-community_property_light.svg';
import atlassianDesignPropertyDark from './_assets/thumbnails/atlassian-design_property_dark.svg';
import atlassianDesignProperty from './_assets/thumbnails/atlassian-design_property_light.svg';
import atlassianDeveloperPropertyDark from './_assets/thumbnails/atlassian-developer_property_dark.svg';
import atlassianDeveloperProperty from './_assets/thumbnails/atlassian-developer_property_light.svg';
import atlassianDocumentationPropertyDark from './_assets/thumbnails/atlassian-documentation_property_dark.svg';
import atlassianDocumentationProperty from './_assets/thumbnails/atlassian-documentation_property_light.svg';
import atlassianEcosystemPropertyDark from './_assets/thumbnails/atlassian-ecosystem_property_dark.svg';
import atlassianEcosystemProperty from './_assets/thumbnails/atlassian-ecosystem_property_light.svg';
import atlassianEnterprisePropertyDark from './_assets/thumbnails/atlassian-enterprise_property_dark.svg';
import atlassianEnterpriseProperty from './_assets/thumbnails/atlassian-enterprise_property_light.svg';
import atlassianFoundationPropertyDark from './_assets/thumbnails/atlassian-foundation_property_dark.svg';
import atlassianFoundationProperty from './_assets/thumbnails/atlassian-foundation_property_light.svg';
import atlassianMarketplacePropertyDark from './_assets/thumbnails/atlassian-marketplace_property_dark.svg';
import atlassianMarketplaceProperty from './_assets/thumbnails/atlassian-marketplace_property_light.svg';
import atlassianPartnerPropertyDark from './_assets/thumbnails/atlassian-partner_property_dark.svg';
import atlassianPartnerProperty from './_assets/thumbnails/atlassian-partner_property_light.svg';
import atlassianSupportPropertyDark from './_assets/thumbnails/atlassian-support_property_dark.svg';
import atlassianSupportProperty from './_assets/thumbnails/atlassian-support_property_light.svg';
import atlassianUniversityPropertyDark from './_assets/thumbnails/atlassian-university_property_dark.svg';
import atlassianUniversityProperty from './_assets/thumbnails/atlassian-university_property_light.svg';
import atlassianLogoDark from './_assets/thumbnails/atlassian_logo_dark.svg';
import atlassianLogo from './_assets/thumbnails/atlassian_logo_light.svg';
import bambooAppDark from './_assets/thumbnails/bamboo_app_dark.svg';
import bambooApp from './_assets/thumbnails/bamboo_app_light.svg';
import bitbucketAppDark from './_assets/thumbnails/bitbucket_app_dark.svg';
import bitbucketApp from './_assets/thumbnails/bitbucket_app_light.svg';
import bitbucketAttributionDark from './_assets/thumbnails/bitbucket_attribution_dark.svg';
import bitbucketAttribution from './_assets/thumbnails/bitbucket_attribution_light.svg';
import chatAppDark from './_assets/thumbnails/chat_app_dark.svg';
import chatApp from './_assets/thumbnails/chat_app_light.svg';
import cloverAppDark from './_assets/thumbnails/clover_app_dark.svg';
import cloverApp from './_assets/thumbnails/clover_app_light.svg';
import compassAppDark from './_assets/thumbnails/compass_app_dark.svg';
import compassApp from './_assets/thumbnails/compass_app_light.svg';
import compassAttributionDark from './_assets/thumbnails/compass_attribution_dark.svg';
import compassAttribution from './_assets/thumbnails/compass_attribution_light.svg';
import confluenceAppDark from './_assets/thumbnails/confluence_app_dark.svg';
import confluenceApp from './_assets/thumbnails/confluence_app_light.svg';
import confluenceAttributionDark from './_assets/thumbnails/confluence_attribution_dark.svg';
import confluenceAttribution from './_assets/thumbnails/confluence_attribution_light.svg';
import crowdAppDark from './_assets/thumbnails/crowd_app_dark.svg';
import crowdApp from './_assets/thumbnails/crowd_app_light.svg';
import crucibleAppDark from './_assets/thumbnails/crucible_app_dark.svg';
import crucibleApp from './_assets/thumbnails/crucible_app_light.svg';
import customerServiceManagementAppDark from './_assets/thumbnails/customer-service-management_app_dark.svg';
import customerServiceManagementApp from './_assets/thumbnails/customer-service-management_app_light.svg';
import customerServiceManagementAttributionDark from './_assets/thumbnails/customer-service-management_attribution_dark.svg';
import customerServiceManagementAttribution from './_assets/thumbnails/customer-service-management_attribution_light.svg';
import fisheyeAppDark from './_assets/thumbnails/fisheye_app_dark.svg';
import fisheyeApp from './_assets/thumbnails/fisheye_app_light.svg';
import focusAppDark from './_assets/thumbnails/focus_app_dark.svg';
import focusApp from './_assets/thumbnails/focus_app_light.svg';
import focusAttributionDark from './_assets/thumbnails/focus_attribution_dark.svg';
import focusAttribution from './_assets/thumbnails/focus_attribution_light.svg';
import goalsAppDark from './_assets/thumbnails/goals_app_dark.svg';
import goalsApp from './_assets/thumbnails/goals_app_light.svg';
import goalsAttributionDark from './_assets/thumbnails/goals_attribution_dark.svg';
import goalsAttribution from './_assets/thumbnails/goals_attribution_light.svg';
import guardAppDark from './_assets/thumbnails/guard_app_dark.svg';
import guardApp from './_assets/thumbnails/guard_app_light.svg';
import guardAttributionDark from './_assets/thumbnails/guard_attribution_dark.svg';
import guardAttribution from './_assets/thumbnails/guard_attribution_light.svg';
import homeAppDark from './_assets/thumbnails/home_app_dark.svg';
import homeApp from './_assets/thumbnails/home_app_light.svg';
import homeAttributionDark from './_assets/thumbnails/home_attribution_dark.svg';
import homeAttribution from './_assets/thumbnails/home_attribution_light.svg';
import hubAppDark from './_assets/thumbnails/hub_app_dark.svg';
import hubApp from './_assets/thumbnails/hub_app_light.svg';
import hubAttributionDark from './_assets/thumbnails/hub_attribution_dark.svg';
import hubAttribution from './_assets/thumbnails/hub_attribution_light.svg';
import jiraAlignAppDark from './_assets/thumbnails/jira-align_app_dark.svg';
import jiraAlignApp from './_assets/thumbnails/jira-align_app_light.svg';
import jiraAlignAttributionDark from './_assets/thumbnails/jira-align_attribution_dark.svg';
import jiraAlignAttribution from './_assets/thumbnails/jira-align_attribution_light.svg';
import jiraProductDiscoveryAppDark from './_assets/thumbnails/jira-product-discovery_app_dark.svg';
import jiraProductDiscoveryApp from './_assets/thumbnails/jira-product-discovery_app_light.svg';
import jiraProductDiscoveryAttributionDark from './_assets/thumbnails/jira-product-discovery_attribution_dark.svg';
import jiraProductDiscoveryAttribution from './_assets/thumbnails/jira-product-discovery_attribution_light.svg';
import jiraServiceManagementAppDark from './_assets/thumbnails/jira-service-management_app_dark.svg';
import jiraServiceManagementApp from './_assets/thumbnails/jira-service-management_app_light.svg';
import jiraServiceManagementAttributionDark from './_assets/thumbnails/jira-service-management_attribution_dark.svg';
import jiraServiceManagementAttribution from './_assets/thumbnails/jira-service-management_attribution_light.svg';
import jiraAppDark from './_assets/thumbnails/jira_app_dark.svg';
import jiraApp from './_assets/thumbnails/jira_app_light.svg';
import jiraAttributionDark from './_assets/thumbnails/jira_attribution_dark.svg';
import jiraAttribution from './_assets/thumbnails/jira_attribution_light.svg';
import loomAppDark from './_assets/thumbnails/loom_app_dark.svg';
import loomApp from './_assets/thumbnails/loom_app_light.svg';
import loomAttributionDark from './_assets/thumbnails/loom_attribution_dark.svg';
import loomAttribution from './_assets/thumbnails/loom_attribution_light.svg';
import opsgenieAppDark from './_assets/thumbnails/opsgenie_app_dark.svg';
import opsgenieApp from './_assets/thumbnails/opsgenie_app_light.svg';
import opsgenieAttributionDark from './_assets/thumbnails/opsgenie_attribution_dark.svg';
import opsgenieAttribution from './_assets/thumbnails/opsgenie_attribution_light.svg';
import projectsAppDark from './_assets/thumbnails/projects_app_dark.svg';
import projectsApp from './_assets/thumbnails/projects_app_light.svg';
import projectsAttributionDark from './_assets/thumbnails/projects_attribution_dark.svg';
import projectsAttribution from './_assets/thumbnails/projects_attribution_light.svg';
import rovoAppDark from './_assets/thumbnails/rovo_app_dark.svg';
import rovoApp from './_assets/thumbnails/rovo_app_light.svg';
import rovoAttributionDark from './_assets/thumbnails/rovo_attribution_dark.svg';
import rovoAttribution from './_assets/thumbnails/rovo_attribution_light.svg';
import searchAppDark from './_assets/thumbnails/search_app_dark.svg';
import searchApp from './_assets/thumbnails/search_app_light.svg';
import searchAttributionDark from './_assets/thumbnails/search_attribution_dark.svg';
import searchAttribution from './_assets/thumbnails/search_attribution_light.svg';
import sourcetreeAppDark from './_assets/thumbnails/sourcetree_app_dark.svg';
import sourcetreeApp from './_assets/thumbnails/sourcetree_app_light.svg';
import sourcetreeAttributionDark from './_assets/thumbnails/sourcetree_attribution_dark.svg';
import sourcetreeAttribution from './_assets/thumbnails/sourcetree_attribution_light.svg';
import statuspageAppDark from './_assets/thumbnails/statuspage_app_dark.svg';
import statuspageApp from './_assets/thumbnails/statuspage_app_light.svg';
import statuspageAttributionDark from './_assets/thumbnails/statuspage_attribution_dark.svg';
import statuspageAttribution from './_assets/thumbnails/statuspage_attribution_light.svg';
import studioAppDark from './_assets/thumbnails/studio_app_dark.svg';
import studioApp from './_assets/thumbnails/studio_app_light.svg';
import studioAttributionDark from './_assets/thumbnails/studio_attribution_dark.svg';
import studioAttribution from './_assets/thumbnails/studio_attribution_light.svg';
import talentAppDark from './_assets/thumbnails/talent_app_dark.svg';
import talentApp from './_assets/thumbnails/talent_app_light.svg';
import talentAttributionDark from './_assets/thumbnails/talent_attribution_dark.svg';
import talentAttribution from './_assets/thumbnails/talent_attribution_light.svg';
import teamsAppDark from './_assets/thumbnails/teams_app_dark.svg';
import teamsApp from './_assets/thumbnails/teams_app_light.svg';
import teamsAttributionDark from './_assets/thumbnails/teams_attribution_dark.svg';
import teamsAttribution from './_assets/thumbnails/teams_attribution_light.svg';
import trelloAppDark from './_assets/thumbnails/trello_app_dark.svg';
import trelloApp from './_assets/thumbnails/trello_app_light.svg';
import trelloAttributionDark from './_assets/thumbnails/trello_attribution_dark.svg';
import trelloAttribution from './_assets/thumbnails/trello_attribution_light.svg';

const logoAssets = [
	{
		title: 'Atlassian',
		url: withAssetPrefix('/logos/atlassian_logo.zip'),
		fileSize: 108902,
		thumbnailLightUrl: atlassianLogo,
		thumbnailDarkUrl: atlassianLogoDark,
	},
];

const attributionAssets = [
	{
		title: 'Analytics',
		url: withAssetPrefix('/logos/analytics_attribution.zip'),
		fileSize: 54583,
		thumbnailLightUrl: analyticsAttribution,
		thumbnailDarkUrl: analyticsAttributionDark,
	},
	{
		title: 'Assets',
		url: withAssetPrefix('/logos/assets_attribution.zip'),
		fileSize: 42464,
		thumbnailLightUrl: assetsAttribution,
		thumbnailDarkUrl: assetsAttributionDark,
	},
	{
		title: 'Atlas',
		url: withAssetPrefix('/logos/atlas_attribution.zip'),
		fileSize: 44135,
		thumbnailLightUrl: atlasAttribution,
		thumbnailDarkUrl: atlasAttributionDark,
	},
	{
		title: 'Bitbucket',
		url: withAssetPrefix('/logos/bitbucket_attribution.zip'),
		fileSize: 57256,
		thumbnailLightUrl: bitbucketAttribution,
		thumbnailDarkUrl: bitbucketAttributionDark,
	},
	{
		title: 'Compass',
		url: withAssetPrefix('/logos/compass_attribution.zip'),
		fileSize: 55240,
		thumbnailLightUrl: compassAttribution,
		thumbnailDarkUrl: compassAttributionDark,
	},
	{
		title: 'Confluence',
		url: withAssetPrefix('/logos/confluence_attribution.zip'),
		fileSize: 64012,
		thumbnailLightUrl: confluenceAttribution,
		thumbnailDarkUrl: confluenceAttributionDark,
	},
	{
		title: 'Customer Service Management',
		url: withAssetPrefix('/logos/customer-service-management_attribution.zip'),
		fileSize: 227932,
		thumbnailLightUrl: customerServiceManagementAttribution,
		thumbnailDarkUrl: customerServiceManagementAttributionDark,
	},
	{
		title: 'Focus',
		url: withAssetPrefix('/logos/focus_attribution.zip'),
		fileSize: 32286,
		thumbnailLightUrl: focusAttribution,
		thumbnailDarkUrl: focusAttributionDark,
	},
	{
		title: 'Goals',
		url: withAssetPrefix('/logos/goals_attribution.zip'),
		fileSize: 38229,
		thumbnailLightUrl: goalsAttribution,
		thumbnailDarkUrl: goalsAttributionDark,
	},
	{
		title: 'Guard',
		url: withAssetPrefix('/logos/guard_attribution.zip'),
		fileSize: 31549,
		thumbnailLightUrl: guardAttribution,
		thumbnailDarkUrl: guardAttributionDark,
	},
	{
		title: 'Home',
		url: withAssetPrefix('/logos/home_attribution.zip'),
		fileSize: 41894,
		thumbnailLightUrl: homeAttribution,
		thumbnailDarkUrl: homeAttributionDark,
	},
	{
		title: 'Hub',
		url: withAssetPrefix('/logos/hub_attribution.zip'),
		fileSize: 37132,
		thumbnailLightUrl: hubAttribution,
		thumbnailDarkUrl: hubAttributionDark,
	},
	{
		title: 'Jira',
		url: withAssetPrefix('/logos/jira_attribution.zip'),
		fileSize: 47183,
		thumbnailLightUrl: jiraAttribution,
		thumbnailDarkUrl: jiraAttributionDark,
	},
	{
		title: 'Jira Align',
		url: withAssetPrefix('/logos/jira-align_attribution.zip'),
		fileSize: 73077,
		thumbnailLightUrl: jiraAlignAttribution,
		thumbnailDarkUrl: jiraAlignAttributionDark,
	},
	{
		title: 'Jira Product Discovery',
		url: withAssetPrefix('/logos/jira-product-discovery_attribution.zip'),
		fileSize: 179021,
		thumbnailLightUrl: jiraProductDiscoveryAttribution,
		thumbnailDarkUrl: jiraProductDiscoveryAttributionDark,
	},
	{
		title: 'Jira Service Management',
		url: withAssetPrefix('/logos/jira-service-management_attribution.zip'),
		fileSize: 183234,
		thumbnailLightUrl: jiraServiceManagementAttribution,
		thumbnailDarkUrl: jiraServiceManagementAttributionDark,
	},
	{
		title: 'Loom',
		url: withAssetPrefix('/logos/loom_attribution.zip'),
		fileSize: 102749,
		thumbnailLightUrl: loomAttribution,
		thumbnailDarkUrl: loomAttributionDark,
	},
	{
		title: 'Opsgenie',
		url: withAssetPrefix('/logos/opsgenie_attribution.zip'),
		fileSize: 63647,
		thumbnailLightUrl: opsgenieAttribution,
		thumbnailDarkUrl: opsgenieAttributionDark,
	},
	{
		title: 'Projects',
		url: withAssetPrefix('/logos/projects_attribution.zip'),
		fileSize: 54400,
		thumbnailLightUrl: projectsAttribution,
		thumbnailDarkUrl: projectsAttributionDark,
	},
	{
		title: 'Rovo',
		url: withAssetPrefix('/logos/rovo_attribution.zip'),
		fileSize: 373436,
		thumbnailLightUrl: rovoAttribution,
		thumbnailDarkUrl: rovoAttributionDark,
	},
	{
		title: 'Search',
		url: withAssetPrefix('/logos/search_attribution.zip'),
		fileSize: 54600,
		thumbnailLightUrl: searchAttribution,
		thumbnailDarkUrl: searchAttributionDark,
	},
	{
		title: 'Sourcetree',
		url: withAssetPrefix('/logos/sourcetree_attribution.zip'),
		fileSize: 68496,
		thumbnailLightUrl: sourcetreeAttribution,
		thumbnailDarkUrl: sourcetreeAttributionDark,
	},
	{
		title: 'Statuspage',
		url: withAssetPrefix('/logos/statuspage_attribution.zip'),
		fileSize: 73630,
		thumbnailLightUrl: statuspageAttribution,
		thumbnailDarkUrl: statuspageAttributionDark,
	},
	{
		title: 'Studio',
		url: withAssetPrefix('/logos/studio_attribution.zip'),
		fileSize: 50290,
		thumbnailLightUrl: studioAttribution,
		thumbnailDarkUrl: studioAttributionDark,
	},
	{
		title: 'Talent',
		url: withAssetPrefix('/logos/talent_attribution.zip'),
		fileSize: 57389,
		thumbnailLightUrl: talentAttribution,
		thumbnailDarkUrl: talentAttributionDark,
	},
	{
		title: 'Teams',
		url: withAssetPrefix('/logos/teams_attribution.zip'),
		fileSize: 55354,
		thumbnailLightUrl: teamsAttribution,
		thumbnailDarkUrl: teamsAttributionDark,
	},
	{
		title: 'Trello',
		url: withAssetPrefix('/logos/trello_attribution.zip'),
		fileSize: 47028,
		thumbnailLightUrl: trelloAttribution,
		thumbnailDarkUrl: trelloAttributionDark,
	},
];

const propertyAssets = [
	{
		title: 'Atlassian Access',
		url: withAssetPrefix('/logos/atlassian-access_property.zip'),
		fileSize: 39783,
		thumbnailLightUrl: atlassianAccessProperty,
		thumbnailDarkUrl: atlassianAccessPropertyDark,
	},
	{
		title: 'Atlassian Blog',
		url: withAssetPrefix('/logos/atlassian-blog_property.zip'),
		fileSize: 78644,
		thumbnailLightUrl: atlassianBlogProperty,
		thumbnailDarkUrl: atlassianBlogPropertyDark,
	},
	{
		title: 'Atlassian Certification',
		url: withAssetPrefix('/logos/atlassian-certification_property.zip'),
		fileSize: 99027,
		thumbnailLightUrl: atlassianCertificationProperty,
		thumbnailDarkUrl: atlassianCertificationPropertyDark,
	},
	{
		title: 'Atlassian Community',
		url: withAssetPrefix('/logos/atlassian-community_property.zip'),
		fileSize: 94275,
		thumbnailLightUrl: atlassianCommunityProperty,
		thumbnailDarkUrl: atlassianCommunityPropertyDark,
	},
	{
		title: 'Atlassian Design',
		url: withAssetPrefix('/logos/atlassian-design_property.zip'),
		fileSize: 82235,
		thumbnailLightUrl: atlassianDesignProperty,
		thumbnailDarkUrl: atlassianDesignPropertyDark,
	},
	{
		title: 'Atlassian Developer',
		url: withAssetPrefix('/logos/atlassian-developer_property.zip'),
		fileSize: 96926,
		thumbnailLightUrl: atlassianDeveloperProperty,
		thumbnailDarkUrl: atlassianDeveloperPropertyDark,
	},
	{
		title: 'Atlassian Documentation',
		url: withAssetPrefix('/logos/atlassian-documentation_property.zip'),
		fileSize: 106271,
		thumbnailLightUrl: atlassianDocumentationProperty,
		thumbnailDarkUrl: atlassianDocumentationPropertyDark,
	},
	{
		title: 'Atlassian Ecosystem',
		url: withAssetPrefix('/logos/atlassian-ecosystem_property.zip'),
		fileSize: 101354,
		thumbnailLightUrl: atlassianEcosystemProperty,
		thumbnailDarkUrl: atlassianEcosystemPropertyDark,
	},
	{
		title: 'Atlassian Enterprise',
		url: withAssetPrefix('/logos/atlassian-enterprise_property.zip'),
		fileSize: 89203,
		thumbnailLightUrl: atlassianEnterpriseProperty,
		thumbnailDarkUrl: atlassianEnterprisePropertyDark,
	},
	{
		title: 'Atlassian Foundation',
		url: withAssetPrefix('/logos/atlassian-foundation_property.zip'),
		fileSize: 90543,
		thumbnailLightUrl: atlassianFoundationProperty,
		thumbnailDarkUrl: atlassianFoundationPropertyDark,
	},
	{
		title: 'Atlassian Marketplace',
		url: withAssetPrefix('/logos/atlassian-marketplace_property.zip'),
		fileSize: 104409,
		thumbnailLightUrl: atlassianMarketplaceProperty,
		thumbnailDarkUrl: atlassianMarketplacePropertyDark,
	},
	{
		title: 'Atlassian Partner',
		url: withAssetPrefix('/logos/atlassian-partner_property.zip'),
		fileSize: 78453,
		thumbnailLightUrl: atlassianPartnerProperty,
		thumbnailDarkUrl: atlassianPartnerPropertyDark,
	},
	{
		title: 'Atlassian Support',
		url: withAssetPrefix('/logos/atlassian-support_property.zip'),
		fileSize: 84542,
		thumbnailLightUrl: atlassianSupportProperty,
		thumbnailDarkUrl: atlassianSupportPropertyDark,
	},
	{
		title: 'Atlassian University',
		url: withAssetPrefix('/logos/atlassian-university_property.zip'),
		fileSize: 94044,
		thumbnailLightUrl: atlassianUniversityProperty,
		thumbnailDarkUrl: atlassianUniversityPropertyDark,
	},
];

const appAssets = [
	{
		title: 'Home',
		url: withAssetPrefix('/logos/home_app.zip'),
		fileSize: 26030,
		thumbnailLightUrl: homeApp,
		thumbnailDarkUrl: homeAppDark,
	},
	{
		title: 'Jira',
		url: withAssetPrefix('/logos/jira_app.zip'),
		fileSize: 25402,
		thumbnailLightUrl: jiraApp,
		thumbnailDarkUrl: jiraAppDark,
	},
	{
		title: 'Confluence',
		url: withAssetPrefix('/logos/confluence_app.zip'),
		fileSize: 47998,
		thumbnailLightUrl: confluenceApp,
		thumbnailDarkUrl: confluenceAppDark,
	},
	{
		title: 'Loom',
		url: withAssetPrefix('/logos/loom_app.zip'),
		fileSize: 65583,
		thumbnailLightUrl: loomApp,
		thumbnailDarkUrl: loomAppDark,
	},
	{
		title: 'Focus',
		url: withAssetPrefix('/logos/focus_app.zip'),
		fileSize: 32286,
		thumbnailLightUrl: focusApp,
		thumbnailDarkUrl: focusAppDark,
	},
	{
		title: 'Talent',
		url: withAssetPrefix('/logos/talent_app.zip'),
		fileSize: 47121,
		thumbnailLightUrl: talentApp,
		thumbnailDarkUrl: talentAppDark,
	},
	{
		title: 'Jira Product Discovery',
		url: withAssetPrefix('/logos/jira-product-discovery_app.zip'),
		fileSize: 145265,
		thumbnailLightUrl: jiraProductDiscoveryApp,
		thumbnailDarkUrl: jiraProductDiscoveryAppDark,
	},
	{
		title: 'Compass',
		url: withAssetPrefix('/logos/compass_app.zip'),
		fileSize: 38848,
		thumbnailLightUrl: compassApp,
		thumbnailDarkUrl: compassAppDark,
	},
	{
		title: 'Bitbucket',
		url: withAssetPrefix('/logos/bitbucket_app.zip'),
		fileSize: 40521,
		thumbnailLightUrl: bitbucketApp,
		thumbnailDarkUrl: bitbucketAppDark,
	},
	{
		title: 'Jira Service Management',
		url: withAssetPrefix('/logos/jira-service-management_app.zip'),
		fileSize: 149689,
		thumbnailLightUrl: jiraServiceManagementApp,
		thumbnailDarkUrl: jiraServiceManagementAppDark,
	},
	{
		title: 'Assets',
		url: withAssetPrefix('/logos/assets_app.zip'),
		fileSize: 42464,
		thumbnailLightUrl: assetsApp,
		thumbnailDarkUrl: assetsAppDark,
	},
	{
		title: 'Opsgenie',
		url: withAssetPrefix('/logos/opsgenie_app.zip'),
		fileSize: 48078,
		thumbnailLightUrl: opsgenieApp,
		thumbnailDarkUrl: opsgenieAppDark,
	},
	{
		title: 'Trello',
		url: withAssetPrefix('/logos/trello_app.zip'),
		fileSize: 30895,
		thumbnailLightUrl: trelloApp,
		thumbnailDarkUrl: trelloAppDark,
	},
	{
		title: 'Goals',
		url: withAssetPrefix('/logos/goals_app.zip'),
		fileSize: 38229,
		thumbnailLightUrl: goalsApp,
		thumbnailDarkUrl: goalsAppDark,
	},
	{
		title: 'Teams',
		url: withAssetPrefix('/logos/teams_app.zip'),
		fileSize: 39481,
		thumbnailLightUrl: teamsApp,
		thumbnailDarkUrl: teamsAppDark,
	},
	{
		title: 'Search',
		url: withAssetPrefix('/logos/search_app.zip'),
		fileSize: 38680,
		thumbnailLightUrl: searchApp,
		thumbnailDarkUrl: searchAppDark,
	},
	{
		title: 'Chat',
		url: withAssetPrefix('/logos/chat_app.zip'),
		fileSize: 27047,
		thumbnailLightUrl: chatApp,
		thumbnailDarkUrl: chatAppDark,
	},
	{
		title: 'Studio',
		url: withAssetPrefix('/logos/studio_app.zip'),
		fileSize: 34649,
		thumbnailLightUrl: studioApp,
		thumbnailDarkUrl: studioAppDark,
	},
	{
		title: 'Analytics',
		url: withAssetPrefix('/logos/analytics_app.zip'),
		fileSize: 38879,
		thumbnailLightUrl: analyticsApp,
		thumbnailDarkUrl: analyticsAppDark,
	},
	{
		title: 'Hub',
		url: withAssetPrefix('/logos/hub_app.zip'),
		fileSize: 20203,
		thumbnailLightUrl: hubApp,
		thumbnailDarkUrl: hubAppDark,
	},
	{
		title: 'Projects',
		url: withAssetPrefix('/logos/projects_app.zip'),
		fileSize: 39217,
		thumbnailLightUrl: projectsApp,
		thumbnailDarkUrl: projectsAppDark,
	},
	{
		title: 'Guard',
		url: withAssetPrefix('/logos/guard_app.zip'),
		fileSize: 31549,
		thumbnailLightUrl: guardApp,
		thumbnailDarkUrl: guardAppDark,
	},
	{
		title: 'Rovo',
		url: withAssetPrefix('/logos/rovo_app.zip'),
		fileSize: 483581,
		thumbnailLightUrl: rovoApp,
		thumbnailDarkUrl: rovoAppDark,
	},
	{
		title: 'Sourcetree',
		url: withAssetPrefix('/logos/sourcetree_app.zip'),
		fileSize: 52769,
		thumbnailLightUrl: sourcetreeApp,
		thumbnailDarkUrl: sourcetreeAppDark,
	},
	{
		title: 'Customer Service Management',
		url: withAssetPrefix('/logos/customer-service-management_app.zip'),
		fileSize: 188071,
		thumbnailLightUrl: customerServiceManagementApp,
		thumbnailDarkUrl: customerServiceManagementAppDark,
	},
	{
		title: 'Statuspage',
		url: withAssetPrefix('/logos/statuspage_app.zip'),
		fileSize: 57791,
		thumbnailLightUrl: statuspageApp,
		thumbnailDarkUrl: statuspageAppDark,
	},
	{
		title: 'Jira Align',
		url: withAssetPrefix('/logos/jira-align_app.zip'),
		fileSize: 70390,
		thumbnailLightUrl: jiraAlignApp,
		thumbnailDarkUrl: jiraAlignAppDark,
	},
	{
		title: 'Atlas',
		url: withAssetPrefix('/logos/atlas_app.zip'),
		fileSize: 50715,
		thumbnailLightUrl: atlasApp,
		thumbnailDarkUrl: atlasAppDark,
	},
	{
		title: 'Bamboo',
		url: withAssetPrefix('/logos/bamboo_app.zip'),
		fileSize: 46066,
		thumbnailLightUrl: bambooApp,
		thumbnailDarkUrl: bambooAppDark,
	},
	{
		title: 'Clover',
		url: withAssetPrefix('/logos/clover_app.zip'),
		fileSize: 40001,
		thumbnailLightUrl: cloverApp,
		thumbnailDarkUrl: cloverAppDark,
	},
	{
		title: 'Crowd',
		url: withAssetPrefix('/logos/crowd_app.zip'),
		fileSize: 39032,
		thumbnailLightUrl: crowdApp,
		thumbnailDarkUrl: crowdAppDark,
	},
	{
		title: 'Crucible',
		url: withAssetPrefix('/logos/crucible_app.zip'),
		fileSize: 41680,
		thumbnailLightUrl: crucibleApp,
		thumbnailDarkUrl: crucibleAppDark,
	},
	{
		title: 'Fisheye',
		url: withAssetPrefix('/logos/fisheye_app.zip'),
		fileSize: 42675,
		thumbnailLightUrl: fisheyeApp,
		thumbnailDarkUrl: fisheyeAppDark,
	},
];

/**
 * @codegenEnd
 */

export const AtlassianLogoCard = (): React.JSX.Element => (
	<AssetCard
		title={logoAssets[0].title}
		link={logoAssets[0].url}
		fileSize={logoAssets[0].fileSize}
		thumbnail={{
			light: logoAssets[0].thumbnailLightUrl,
			// Dark thumbnail defaults to light if not set
			dark: logoAssets[0].thumbnailDarkUrl || logoAssets[0].thumbnailLightUrl,
		}}
	/>
);

export const AttributionCards = (): React.JSX.Element => {
	return (
		<Stack space="space.100">
			{attributionAssets.map((asset, index) => {
				return (
					<AssetCard
						key={index}
						title={asset.title}
						link={asset.url}
						fileSize={asset.fileSize}
						thumbnail={{
							light: asset.thumbnailLightUrl,
							// Dark thumbnail defaults to light if not set
							dark: asset.thumbnailDarkUrl || asset.thumbnailLightUrl,
						}}
					/>
				);
			})}
		</Stack>
	);
};

export const PropertyCards = (): React.JSX.Element => {
	return (
		<Stack space="space.100">
			{propertyAssets.map((asset, index) => {
				return (
					<AssetCard
						key={index}
						title={asset.title}
						link={asset.url}
						fileSize={asset.fileSize}
						thumbnail={{
							light: asset.thumbnailLightUrl,
							// Dark thumbnail defaults to light if not set
							dark: asset.thumbnailDarkUrl || asset.thumbnailLightUrl,
						}}
					/>
				);
			})}
		</Stack>
	);
};

export const AppCards = (): React.JSX.Element => {
	return (
		<Stack space="space.100">
			{appAssets.map((asset, index) => {
				return (
					<AssetCard
						key={index}
						title={asset.title}
						link={asset.url}
						fileSize={asset.fileSize}
						thumbnail={{
							light: asset.thumbnailLightUrl,
							// Dark thumbnail defaults to light if not set
							dark: asset.thumbnailDarkUrl || asset.thumbnailLightUrl,
						}}
					/>
				);
			})}
		</Stack>
	);
};
